<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50" v-on="$listeners">
        <defs>
            <clipPath id="clip-Arrow_back_">
                <rect width="50" height="50"/>
            </clipPath>
        </defs>
        <g id="Arrow_back_" data-name="Arrow back " clip-path="url(#clip-Arrow_back_)">
            <g id="Groupe_3108" data-name="Groupe 3108" transform="translate(-14.084 -967.229)">
                <path id="Tracé_2101" data-name="Tracé 2101" d="M29.25,993.078l8.032,9.036a1.011,1.011,0,0,0,1.42.071,1.044,1.044,0,0,0,.071-1.42l-6.542-7.358H49.08a1,1,0,0,0,0-2.008H32.231l6.542-7.357a1.057,1.057,0,0,0-.071-1.42,1.017,1.017,0,0,0-1.42.071l-8.032,9.036A1.034,1.034,0,0,0,29.25,993.078Z" transform="translate(0)" :fill="color"/>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'ArrowLeft',
    mixins: [Colorable],
};
</script>
